module.exports = __webpack_public_path__ + "static/media/users.23941887.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/console-menu/users.svg
// module id = 1408
// module chunks = 0